// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  associatedPress: (t, data?, options?) => t('enum.license-partner.associated-press.name', data, options),
  /* eslint-enable max-len */
};
